<div class="header_search header_search_mobile">
  <div class="title-page">
    <h3>{{title}}</h3>
  </div>
  <div class="content_search">
    <div class="new-demand">
      <button class="btn-back" type="btn" (click)="deletedActive = !deletedActive">{{!deletedActive ? 'Mostrar': 'Ocultar'}} Excluídas</button>
    </div>
    <div class="new-demand" *ngIf="permission?.createPermission">
      <button class="btn btn-primary" type="btn" *ngIf="!ordenacao" (click)="ordenacao = true">Ordenação</button>
      <button class="btn btn-primary" type="btn" *ngIf="ordenacao" (click)="salvarOrdem()">Salvar Ordem</button>
    </div>
    <div class="new-demand" *ngIf="permission?.actionNewSit">
      <button class="btn btn-primary" type="btn" (click)="solicitarNovaSituacao()">Solicitar nova situação</button>
    </div>
    <div class="new-demand" *ngIf="permission?.createPermission">
      <a class="btn btn-primary" type="btn" [routerLink]="newViewLink()" [queryParams]="novoParams()">Nova {{idEntrega ? 'Ação': 'Atividade'}}</a>
    </div>
  </div>
</div>

<div class="system-table table-container">
  <div class="system-table-conteiner">
    <table cdkDropList (cdkDropListDropped)="drop($event)" [cdkDropListDisabled]="!ordenacao" [ngClass]="{'ordenacao': ordenacao}">
      <thead>
        <tr>
          <th>{{idEntrega ? 'Plano de Ação': 'Atividade'}}</th>
          <th class="text-center">Status</th>
          <th>{{idEntrega ? 'Término planejado': 'Linha de Base'}}</th>
          <th class="text-center">Término previsto</th>
          <th class="text-center">Atualização</th>
          <th class="text-center btn-icon-td">Ações</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of planoAcao; let i = index">
          <tr cdkDrag *ngIf="!item?.deleted || deletedActive || deletedActiveDrop">
            <td class="title">
              <span class="title-span">{{item?.title}}</span>
              <div class="responsavel">
                <img *ngIf="item?.resp_nome" src="assets/images/svgs/responsavel.svg" alt="Responsavel" [tooltip]="item?.resp_nome" placement="bottom" (click)="viewResonsavel(item)">
              </div>
            </td>
            <td class="status">
              <div>{{item?.status}}</div>
              <div [innerHTML]="item?.status1"></div>
            </td>
            <td class="text-center">{{ item?.deadline_original }}</td>
            <td class="text-center">{{ item?.deadline }}</td>
            <td class="text-center">
              <div>{{ item?.user }}</div>
              <div>{{ item?.ctr_dth_atu }}</div>
            </td>
            <td class="btn-icon-td">
              <div class="btn-icon btn-icon-text">
                <a class="icon-table m-b-sm" [routerLink]="newViewLink(item?.id)" *ngIf="!item?.deleted">
                  <img src="assets/images/svgs/lupa.svg" alt="Visualizar" tooltip="Visualizar" placement="bottom">
                </a>
                <span class="icon-table m-b-sm" (click)="item.analysis_active = !item?.analysis_active" *ngIf="!item?.deleted && item?.description">
                  <img src="assets/images/svgs/arrows-{{item.analysis_active ? 'close' : 'open'}}.svg" alt="Mostrar situação" tooltip="Mostrar situação" placement="bottom">
                </span>
                <a class="icon-table icon-table-text m-b-sm" [routerLink]="novaDemandaLink()" [queryParams]="novaDemandaParams(item?.id)" *ngIf="permission?.canDemand">
                  Nova demanda
                </a>
                <a class="icon-table icon-table-text" [routerLink]="novaSituacao(item?.id)" *ngIf="!item?.deleted && item?.canSituation">
                  Nova situação
                </a>
              </div>
            </td>
          </tr>

          <tr *ngIf="item?.analysis_active && item?.description">
            <td class="title">
              <strong>Situação:</strong>
            </td>
            <td colspan="5">
              {{ item?.description }}
            </td>
          </tr>

          <ng-container *ngIf="item?.analysis_active && item?.analysis?.length">
            <tr>
              <th colspan="2" class="title">Titulo</th>
              <th class="text-center">Unid. Med.</th>
              <th class="text-center">Meta</th>
              <th class="text-center">Realizado</th>
              <th class="text-center">% Real</th>
            </tr>

            <tr *ngFor="let extra of item?.analysis">
              <td colspan="2" class="title">{{extra?.title}}</td>
              <td class="text-center">{{extra?.unit_id}}</td>
              <td class="text-center">{{extra?.goal}}</td>
              <td class="text-center">{{extra?.value_done}}</td>
              <td class="text-center">{{extra?.value_real}}</td>
            </tr>
          </ng-container>
        </ng-container>
        <tr *ngIf="!planoAcao?.length || (deletedVerify() && !deletedActive)" class="border-b-radius">
          <td colspan="6" class="text-center">Nenhum(a) {{offTypeList}} Cadastrado(a) ou Ativo(a).</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<app-loading [loader]="isLoading"></app-loading>
<app-modal-responsavel #modalResonsavel></app-modal-responsavel>